import React from 'react'
import reactCSS from 'reactcss'
import { SketchPicker } from 'react-color'

class ColorPicker extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.handleClick = this.handleClick.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.renderPicker = this.renderPicker.bind(this);
    this.onTransparentChange = this.onTransparentChange.bind(this);
    this.defaultState = this.defaultState.bind(this);
    this.defaultState(props);

  }

  defaultState(props) {
      let show = false;
      if(this.state.displayColorPicker) {
          show = true;
      }

    this.state = {
        isTransparent:(props.color == 'transparent' ? true:false),
        displayColorPicker: show,
        color: {
          hex:props.color
        }
    };
  }

  onTransparentChange() {
    this.setState({
        ...this.state,
        isTransparent: !this.state.isTransparent,
        color: {
            hex:(!this.state.isTransparent == true ? 'transparent':this.state.color.hex)
        }
    });

    this.props.handleColorChange(this.props.id,(!this.state.isTransparent == true ? 'transparent':this.state.color.hex));

  }

  handleClick() {
    this.setState({ displayColorPicker: !this.state.displayColorPicker })
  }

  handleClose(){
    this.setState({ displayColorPicker: false })
  };

  componentWillReceiveProps(nextProps) {
    this.defaultState(nextProps);
    }

  handleChange(color){
    color = color.hex;

    if(this.props.transparent === true) {
        if(this.state.isTransparent) {
            this.setState({...this.state,isTransparent:false,color:{hex:color}});
        }else{
            this.setState({...this.state,color:{hex:color}});
        }
    }else{
        this.setState({...this.state,color:{hex:color}});
    }

    this.props.handleColorChange(this.props.id,color);
  };

  renderPicker() {
    const styles = reactCSS({
      'default': {
        color: {
          width: '100%',
          height: '100%',
          borderRadius: '2px',
          backgroundColor: this.state.color.hex,
        },
        swatch: {
            width:'100%',
            height:'36px',
          padding: '5px',
          background: '#fff',
          borderRadius: '1px',
          boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
          display: 'inline-block',
          cursor: 'pointer',
        },
        popover: {
          position: 'absolute',
          zIndex: '2',
        },
        cover: {
          position: 'fixed',
          top: '0px',
          right: '0px',
          bottom: '0px',
          left: '0px',
        },
      },
    });

    return (
        <div>
            <div style={ styles.swatch } onClick={ this.handleClick }>
                <div style={ styles.color } />
            </div>
            { this.state.displayColorPicker ? <div style={ styles.popover }>
            <div style={ styles.cover } onClick={ this.handleClose }/>
                <SketchPicker color={ this.state.color } onChange={ this.handleChange } />
            </div> : null }

        </div>
    )
  }

  render() {



    if(this.props.transparent === true) {
        return (
            <div className="col-sm-12 p-0">
                <div className="col-sm-8 p-0">
                    {this.renderPicker()}
                </div>
                <div className="col-sm-4">
                    <div className="checkbox-custom checkbox-default">
                        <input type="checkbox" checked={this.state.isTransparent} onChange={this.onTransparentChange} />
                        <label>Transparent</label>
                    </div>
                </div>
            </div>
        );
    }

    return this.renderPicker();
  }
}

export default ColorPicker;




// WEBPACK FOOTER //
// ./components/builder/ColorPicker.js